import { render, staticRenderFns } from "./FlipBookAddToCartBtnEbook.vue?vue&type=template&id=7b8823ec&scoped=true"
import script from "./FlipBookAddToCartBtnEbook.vue?vue&type=script&lang=js"
export * from "./FlipBookAddToCartBtnEbook.vue?vue&type=script&lang=js"
import style0 from "./FlipBookAddToCartBtnEbook.vue?vue&type=style&index=0&id=7b8823ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8823ec",
  null
  
)

export default component.exports